import Vue from 'vue';
import Vuex from 'vuex';

import { product } from './modules/product'
import { layout } from './modules/layout'
import { auth } from './modules/auth'
import { shoppingCart } from './modules/ShoppingCart'
// import { news } from './modules/news'
// import { dropshipping } from './modules/dropshipping'
// import { categories } from './modules/categories'
// import { publications } from './modules/publications'


Vue.use(Vuex)

export default new Vuex.Store({
	state: {},
	mutations: {},
	actions: {},
	modules: {
		product,
		layout,
		auth,
		shoppingCart,
		// news,
		// dropshipping,
		// categories,
		// publications
	}
});
